import { useState } from 'react'

import MuiButton from '@mui/material/Button'
import MuiMenu from '@mui/material/Menu'
import MuiList from '@mui/material/List'
import MuiCollapse from '@mui/material/Collapse'
import MuiListItemButton from '@mui/material/ListItemButton'
import MuiListItemText from '@mui/material/ListItemText'
import MuiListItemIcon from '@mui/material/ListItemIcon'

import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import CampaignIcon from '@mui/icons-material/Campaign'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

const AssignmentToolbar = ({ label, selectedIds, mappedCandidates, handleAssignment }) => {
  const [campaignItemsOpen, setCampaignItemsOpen] = useState([])
  const [assignAnchorEl, setAssignAnchorEl] = useState(null)
  const assignMenuOpen = Boolean(assignAnchorEl)

  const handleAssignMenuClick = (event) => {
    setAssignAnchorEl(event.currentTarget)
  }

  const handleAssignCampaignClick = (campaignId) => {
    if (campaignItemsOpen.includes(campaignId)) {
      setCampaignItemsOpen(campaignItemsOpen.filter((id) => id !== campaignId))
    } else {
      setCampaignItemsOpen([...campaignItemsOpen, campaignId])
    }
  }

  const handleAssignClose = () => {
    setAssignAnchorEl(null)
  }

  const handleAssignToCampaign = (campaignId, candidateId) => {
    handleAssignment(campaignId, candidateId)
    handleAssignClose()
  }

  return (
    <>
      <MuiButton
        size="small"
        startIcon={<CampaignIcon />}
        onClick={handleAssignMenuClick}
        disabled={!selectedIds.length}
      >
        Assign {label}
      </MuiButton>
      <MuiMenu
        id={`campaignAssignMenu${label}`}
        anchorEl={assignAnchorEl}
        open={assignMenuOpen}
        onClose={() => handleAssignClose()}
      >
        {mappedCandidates?.map((campaign) => [
          <MuiListItemButton key={campaign.id} onClick={() => handleAssignCampaignClick(campaign.id)}>
            <MuiListItemText primary={`${campaign.code ? `[${campaign.code}] ` : ''}${campaign.name}`} />
            {campaignItemsOpen.includes(campaign.id) ? <ExpandLess /> : <ExpandMore />}
          </MuiListItemButton>,
          <MuiCollapse in={campaignItemsOpen.includes(campaign.id)}>
            <MuiList component="div" disablePadding>
              {campaign?.candidates?.map((candidate) => (
                <MuiListItemButton
                  key={`${campaign.id}-${candidate.id}`}
                  onClick={() => handleAssignToCampaign(campaign.id, candidate.id)}
                  sx={{ px: 4 }}
                >
                  <MuiListItemIcon>
                    <PersonOutlineIcon />
                  </MuiListItemIcon>
                  <MuiListItemText primary={candidate.name} />
                </MuiListItemButton>
              ))}
            </MuiList>
          </MuiCollapse>,
        ])}
      </MuiMenu>
    </>
  )
}

export default AssignmentToolbar
